import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getFirmByLegacyId } from "../../Services/Firm";
import { getReferralByLegacyId } from "../../Services/Referral";

export function MemberReferralLegacyRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const action = (params.get("action") || "").toLowerCase();
    const id = params.get("id");
    if (action === "add") {
      navigate("/referrals/new", { replace: true });
      return;
    }
    if ((action === "detail" || action === "update") && id) {
      getReferralByLegacyId(id).then((row) => {
        navigate(action === "update" ? `/referrals/${row.id}/edit` : `/referrals/${row.id}`, { replace: true });
      }).catch(() => navigate("/referrals", { replace: true }));
      return;
    }
    navigate("/referrals", { replace: true });
  }, [navigate, params]);

  return null;
}

export function StaffReferralLegacyRedirect() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const action = (params.get("action") || "").toLowerCase();
    const id = params.get("id");
    const firmLegacyId = params.get("pcomp");

    async function go() {
      if ((action === "detail" || action === "update" || action === "delete") && id) {
        try {
          const row = await getReferralByLegacyId(id);
          navigate(action === "update" ? `/staff/referrals/edit/${row.id}` : `/staff/referrals/view/${row.id}`, { replace: true });
          return;
        } catch {
          navigate("/staff/referrals", { replace: true });
          return;
        }
      }
      if (firmLegacyId) {
        try {
          const firm = await getFirmByLegacyId(Number(firmLegacyId));
          const firmPath = `/ManageFirm/Referrals/${firm.id}`;
          navigate(action === "add" ? `${firmPath}/new` : firmPath, { replace: true });
          return;
        } catch {
          navigate("/staff/referrals", { replace: true });
          return;
        }
      }
      navigate(action === "add" ? "/staff/referrals/new" : "/staff/referrals", { replace: true });
    }

    go();
  }, [navigate, params]);

  return null;
}
